export const regexPhoneNumber =
  /^(\+[1-9]{1}[0-9]{0,2}[ -])?([0]{1})?[1-9]{1}[0-9]{2}[0-9]{1}[0-9]{2}[0-9]{3,4}$/;
export const regexEmailString =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
